var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "75.398px",
    height: "75.398px",
    viewBox: "0 0 75.398 75.398",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Profile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.699,75.398 C58.5,75.398 75.398,58.5 75.398,37.699 C75.398,16.898 58.5,0 37.699,0 C16.898,0 0,16.898 0,37.699 C0,58.5 16.898,75.398 37.699,75.398 Z M16.898,61.5 C22.5972,54.6992 30,51 37.699,51 C45.398,51 52.801,54.6992 58.5,61.5 C53,66.3984 45.699,69.3984 37.699,69.3984 C29.699,69.3984 22.398,66.3984 16.898,61.5 Z M37.699,6 C55.199,6 69.398,20.199 69.398,37.699 C69.398,44.9998 66.898,51.801 62.6988,57.097 C55.8004,49.2962 47.0968,44.995 37.6988,44.995 C28.3008,44.995 19.5968,49.2958 12.6988,57.097 C8.4996,51.6986 5.9996,44.995 5.9996,37.699 C5.9996,20.199 20.1986,6 37.6986,6 L37.699,6 Z",
    id: "Shape",
    fill: "#6A655B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.699,42 C46.0974,42 52.898,35.1992 52.898,26.801 C52.898,18.4026 46.0972,11.602 37.699,11.602 C29.3008,11.602 22.5,18.4028 22.5,26.801 C22.5,35.1994 29.3008,42 37.699,42 Z M37.699,17.598 C42.8006,17.598 46.8982,21.6996 46.8982,26.7972 C46.8982,31.8988 42.7966,35.9964 37.699,35.9964 C32.5974,35.9964 28.4998,31.8948 28.4998,26.7972 C28.4998,21.8011 32.5975,17.598 37.699,17.598 Z",
    id: "Shape",
    fill: "#6A655B",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default ForwardRef;